import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalReasonInput } from '../../../api/models/approval';

@Component({
  selector: 'app-approver-reason',
  templateUrl: './approver-reason.component.html',
  styleUrls: ['./approver-reason.component.scss']
})
export class ApproverReasonComponent implements OnInit {

  @Input() type: string;

  reason: string;
  role: string;

  approvalReasonResponse: ApprovalReasonInput = new ApprovalReasonInput();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    if (this.type === 'Tessco_Declined') {
      this.role = 'INITIATOR';
    }
  }

  getModalTitle() {
    if (this.type === 'Approved') {
      return "Reason for Approving this worksheet";
    } else if (this.type === 'Declined') {
      return "Reason for Denying this worksheet";
    } else {
      return "Reason";
    }
  }

  getPlaceHolder() {
    if (this.type === 'Approved') {
      return "Write the reason for approving this worksheet here...";
    } else if (this.type === 'Declined') {
      return "Write the reason for denying this worksheet here...";
    } else {
      return "Write the reason here..";
    }
  }

  getSendButtonText() {
    if (this.type === 'Approved') {
      return "Approve";
    } else if (this.type === 'Declined') {
      return "Deny";
    } else {
      return "Send";
    }
  }

  setTesscoDeclinedBack(role: string) {
    this.role = role;
  }

  submitApprovalReasonResponse() {
    this.approvalReasonResponse.reason = this.reason;
    this.approvalReasonResponse.denyBack = this.role;
    this.activeModal.close(this.approvalReasonResponse);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/comments/approver-reason/approver-reason.component.ts